import { FormControl, FormGroup } from '@angular/forms'
import { Component, OnInit, Input } from '@angular/core'

@Component({
  selector: 'group-field',
  templateUrl: './group-field.component.html',
  styleUrls: ['./group-field.component.css']
})
export class GroupFieldComponent implements OnInit {
  @Input() fieldInstance: FormGroup
  @Input() label: string
  @Input() field: any
  @Input() create?: boolean = false
  @Input('fieldIndex') index: number
  @Input() isRequired: boolean = false
  @Input() inputValidations: any[] = []
  @Input() readOnly: boolean = false
  @Input() path: string
  @Input() isAdmin: boolean = false

  constructor() {}

  ngOnInit() {}

  getGroupFieldControl(title) {
    return this.fieldInstance.get(title)
  }
}
